import { createApp } from "vue";
import App from "@/App.vue";
import * as store from "@/store";
// mdi
import "@mdi/font/css/materialdesignicons.css";

// vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";

const vuetify = createVuetify({
    theme: {
        defaultTheme: "dark",
    },
});

const app = createApp(App);

// register global variables
for (const _key in store) {
    const key = _key as keyof typeof store;
    // condNameMap を provide する際は aliases 込みの effectiveCondNameMap を使う
    if (key === "condNameMap") {
        app.provide("condNameMap", store.effectiveCondNameMap);
    } else {
        app.provide(key, store[key]);
    }
}

app.config.errorHandler = (err) => {
    alert(err);
    console.error(err);
};

app.use(vuetify).mount("#app");
